import { Component } from "@angular/core";
import { PostStore } from "src/stores/post.store";

@Component({
  selector: "app-weekly",
  templateUrl: "./weekly.page.html",
  styleUrls: ["./weekly.page.scss"],
})
export class WeeklyPage {
  constructor(public postStore: PostStore) {}
}
